<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Obras del cliente</h2></v-toolbar-title></pre>
        </v-toolbar>

        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="ordenes"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            @click:row="(item) => $router.push(irAGuardarOrden(item))"
            :item-class="
                () => {
                    return 'pointer';
                }
            "
            :sort-desc="[false]"
        >
            <template v-slot:item.fecha_facturacion="{ item }">
                <span v-if="item.fecha_facturacion">{{
                    item.fecha_facturacion | format_date
                }}</span>
            </template>
            <template v-slot:item.planificacion_fechas.max_fecha="{ item }">
                <template v-if="item.planificacion_fechas">
                    <span v-if="item.planificacion_fechas.max_fecha">{{
                        item.planificacion_fechas.max_fecha | format_date
                    }}</span>
                </template>
            </template>
            <template v-slot:item.contactos="{ item }">
                <span>{{ formatContactos(item.contactos || item.Contactos) }}</span>
            </template>
            <template v-slot:item.tipo="{ item }">
                <span>{{ getTipos(item) }}</span>
            </template>
            <template v-slot:item.pendiente="{ item }">
                <span>{{ item.total - item.cobrado }}</span>
            </template>
            <template v-slot:item.pdf="{ item }">
                <a
                    target="_blank"
                    :href="`/api/pdf-orden/${item.id}`"
                    @click.stop=""
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
export default {
    props: ["ordenes", "idCliente"],
    data() {
        return {
            search: "",
            headers: [
                { text: "Nombre", value: "nombre", sortable: false },
                { text: "Tipo de producto", value: "tipo", sortable: false },
                { text: "Contactos", value: "contactos", sortable: false },
                {
                    text: "Fecha de finalización",
                    value: "fecha_facturacion",
                    sortable: false,
                },
                {
                    text: "Última fecha de planificación",
                    value: "planificacion_fechas.max_fecha",
                    sortable: false,
                },
            ],

            Clientes: [],
        };
    },
    created() {},
    methods: {
        irAGuardarOrden(item) {
            const base = `/guardar-orden?id=${item.id}`;
            if (this.idCliente != null) {
                return `${base}&from=cliente&id_cliente=${this.idCliente}`;
            }
            return base;
        },
        getTipos(item) {
            try {
                let res = "";
                item.productos.forEach((element) => {
                    res += `${element.producto.titulo} `;
                });
                return res;
            } catch (ex) {}
        },
        formatContactos(contactos) {
            if (!contactos || !Array.isArray(contactos) || contactos.length === 0) {
                return "—";
            }
            return contactos
                .map((c) => {
                    const partes = [c.tipo, c.nombre, c.telefono].filter(Boolean);
                    return partes.join(" · ");
                })
                .join(" | ");
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
